import React from 'react';
import { Link } from 'react-router-dom';
const services = [{
  label: 'Mobile Detailing',
  to: '/services/mobile-detailing'
}, {
  label: 'Interior Detailing',
  to: '/services/interior-detailing'
}, {
  label: 'Exterior Detailing',
  to: '/services/exterior-detailing'
}, {
  label: 'Full Car Detail',
  to: '/full-detail'
}, {
  label: 'Engine Bay Detailing',
  to: '/services/engine-bay-detailing'
}, {
  label: 'Headlight Restoration',
  to: '/services/headlight-restoration'
}, {
  label: 'Hybrid Ceramic Spray',
  to: '/services/hybrid-ceramic-spray'
}];
const citiesList = [{
  label: 'Camarillo',
  to: '/service-areas/camarillo'
}, {
  label: 'Ventura',
  to: '/service-areas/ventura'
}, {
  label: 'Thousand Oaks',
  to: '/mobile-detailing-thousand-oaks'
}, {
  label: 'Simi Valley',
  to: '/service-areas/simi-valley'
}, {
  label: 'Moorpark',
  to: '/service-areas/moorpark'
}, {
  label: 'Newbury Park',
  to: '/service-areas/newbury-park'
}, {
  label: 'Westlake Village',
  to: '/service-areas/westlake-village'
}];
export function SeoContent() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-labelledby="seo-content-heading" data-id="element-340" data-mp="3dyy60t5nrz0u">
      <div className="max-w-4xl mx-auto" data-id="element-341" data-mp="3n1ph2rumgsry">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mb-5 prose-h2:mt-12 first:prose-h2:mt-0 prose-h3:text-xl prose-h3:text-yellow-400 prose-p:text-gray-300 prose-p:leading-relaxed prose-li:text-gray-300 prose-strong:text-white prose-a:text-red-500 hover:prose-a:underline" data-id="element-342" data-mp="3mzwa1bg3k6jf">
          <h2 id="seo-content-heading" data-id="element-343" data-mp="9ncb42mhnnds">
            Mobile Detailing in Ventura County, Done Right
          </h2>
          <p data-id="element-344" data-mp="ej9vck0vhdvu">
            <strong data-id="element-345" data-mp="2bdxnjpq5odns">Mike's Pro Detail</strong> is a premium{' '}
            <strong data-id="element-346" data-mp="2bfqtf2sy2tuq">mobile car detailing</strong> company proudly serving{' '}
            <strong data-id="element-347" data-mp="2gdsaji6t8j3k">Ventura County, California</strong>. We bring a fully
            equipped, professional detail shop directly to your driveway, so you
            get a flawless, showroom-quality finish without ever leaving home.
            From{' '}
            <Link to="/service-areas/camarillo" data-id="element-348" data-mp="3sol19yd7p255">
              mobile detailing in Camarillo
            </Link>{' '}
            to{' '}
            <Link to="/service-areas/ventura" data-id="element-349" data-mp="3nogjm50ki1dc">auto detailing in Ventura</Link>
            ,
            our mobile team comes to you with our own water, detailing
            equipment, and premium eco-friendly products. There is no
            drop-off, no waiting room, and no compromise on quality.
          </p>
          <p data-id="element-350" data-mp="f96oxhz0byfl">
            Whether you searched for <em data-id="element-351" data-mp="b838at94xydb">"car detailing near me"</em>,{' '}
            <em data-id="element-352" data-mp="b9eaiomxmy2b">"mobile car detailing Ventura County"</em>, or a specific
            service in your city, you have found the most trusted name in local
            auto detailing. We treat every vehicle as if it were our own,
            combining meticulous hand work with professional-grade equipment to
            deliver results that protect your investment and turn heads.
          </p>

          <h2 data-id="element-353" data-mp="18smkbj3q556u">Why Choose Mobile Detailing?</h2>
          <p data-id="element-354" data-mp="18rbk1t9hmfkh">
            Traditional car washes are fast but harsh — automated brushes and
            recycled water can leave swirl marks and scratches in your clear
            coat. Professional mobile detailing is the opposite: a careful,
            hand-crafted process performed right where you live or work.
            Choosing{' '}
            <Link to="/services/mobile-detailing" data-id="element-355" data-mp="pvv79rerzmb8">
              mobile detailing in Ventura County
            </Link>{' '}
            gives you several major advantages:
          </p>
          <ul data-id="element-356" data-mp="g4gysu4ujc5y">
            <li data-id="element-357" data-mp="g61wgsmgjb81">
              <strong data-id="element-358" data-mp="g5ic759c4aqu">Convenience:</strong> We come to your home, office, or
              apartment. You reclaim hours of your day instead of sitting at a
              shop.
            </li>
            <li data-id="element-359" data-mp="65j7jjg1d4j9">
              <strong data-id="element-360" data-mp="6617or5tk2wg">Quality:</strong> Hand washing, clay bar decontamination,
              and careful interior work that automated washes simply cannot
              match.
            </li>
            <li data-id="element-361" data-mp="3qafkwdrbddhb">
              <strong data-id="element-362" data-mp="3qc0fg3dmowf6">We bring the equipment:</strong> We bring our own water
              and detailing equipment. We require access to a standard
              electrical outlet at the service location.
            </li>
            <li data-id="element-363" data-mp="3ci97gzfjpklk">
              <strong data-id="element-364" data-mp="3cj28djrtpfvs">Protection:</strong> Premium waxes, sealants, and ceramic
              coatings that shield your paint from the Southern California sun
              and coastal salt air.
            </li>
          </ul>

          <h2 data-id="element-365" data-mp="32l4kixdvll3p">Our Professional Detailing Services</h2>
          <p data-id="element-366" data-mp="2xli5ciehlus9">
            We offer a complete range of mobile detailing services for cars,
            trucks, and SUVs across Ventura County. Each service is performed
            on-site and tailored to your vehicle's specific needs.
          </p>

          <h3 data-id="element-367" data-mp="vueubs0oqe76">Interior Detailing</h3>
          <p data-id="element-368" data-mp="14avxp9hfurd8">
            Our{' '}
            <Link to="/services/interior-detailing" data-id="element-369" data-mp="14bp76i7s7uz2">interior detailing</Link>{' '}
            service deep cleans, shampoos, steam sanitizes, and conditions every
            surface inside your cabin. We remove embedded dirt, pet hair,
            stains, and odors, restoring a fresh, like-new feel while improving
            the air quality you breathe on every drive.
          </p>

          <h3 data-id="element-370" data-mp="lcjm7h3215eh">Exterior Detailing</h3>
          <p data-id="element-371" data-mp="ldmcpnwgt5tv">
            Our{' '}
            <Link to="/services/exterior-detailing" data-id="element-372" data-mp="pdn2u5sxf5gr">exterior detailing</Link>{' '}
            service includes a safe hand wash, clay bar treatment, wheel and
            tire cleaning, and a durable wax or sealant. This safely removes
            bonded contaminants, restores deep gloss, and protects your paint
            from UV damage and oxidation.
          </p>

          <h3 data-id="element-373" data-mp="25rmzn7wh6ezs">Full Car Detail</h3>
          <p data-id="element-374" data-mp="2aqzkxo7p7e09">
            Our most popular package, the{' '}
            <Link to="/full-detail" data-id="element-375" data-mp="2apeti7gokb6m">full car detail</Link>,
            combines our complete interior and exterior services for a true
            bumper-to-bumper transformation. It is the most cost-effective way
            to completely reset your vehicle's condition inside and out.
          </p>

          <h3 data-id="element-376" data-mp="1v08n0tn7ysgd">Engine Bay Detailing</h3>
          <p data-id="element-377" data-mp="1q26rh98lx0o0">
            Our{' '}
            <Link to="/services/engine-bay-detailing" data-id="element-378" data-mp="1q2ylifmk2qc6">
              engine bay detailing
            </Link>{' '}
            safely degreases and cleans your engine compartment, making it
            easier to spot leaks, helping prevent heat-trapping grime, and
            dramatically improving your vehicle's presentation and resale value.
          </p>

          <h3 data-id="element-379" data-mp="17bfjoc49pibq">Headlight Restoration</h3>
          <p data-id="element-380" data-mp="17ae886jcatth">
            Cloudy, yellowed headlights are both an eyesore and a safety hazard.
            Our{' '}
            <Link to="/services/headlight-restoration" data-id="element-381" data-mp="jka8495d1c78">
              headlight restoration
            </Link>{' '}
            service permanently removes oxidation and restores crystal-clear
            lenses, improving your nighttime visibility and your car's
            appearance.
          </p>

          <h3 data-id="element-382" data-mp="2v250cpilbpja">Hybrid Ceramic Spray Protection</h3>
          <p data-id="element-383" data-mp="2gcfx8oqxtbgd">
            Our{' '}
            <Link to="/services/hybrid-ceramic-spray" data-id="element-384" data-mp="2gd8y5937t6ql">
              hybrid ceramic spray protection
            </Link>{' '}
            is sprayed on by hand at the end of a detail, adding gloss and
            helping your paint shed water and dirt. It is included in our Wash
            &amp; Wax and Full Detail packages.
          </p>

          <h2 data-id="element-385" data-mp="2zzx3kfooqy2s">Serving All of Ventura County</h2>
          <p data-id="element-386" data-mp="2zyvirjhvax7v">
            As a mobile operation, we bring our detailing service to every
            community in Ventura County. Wherever you are, we come to you with a
            complete, professional detail. Explore our dedicated city pages for
            local information and pricing:
          </p>
          <div className="not-prose grid grid-cols-2 sm:grid-cols-4 gap-3 my-8" data-id="element-387" data-mp="1sn4resuqcqvd">
            {citiesList.map(c => <Link key={c.to} to={c.to} className="block text-center px-3 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold text-sm hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-388" data-mp="2kbhkfhzgnpec">
                {c.label}
              </Link>)}
          </div>
          <p data-id="element-389" data-mp="26b6r88aohyq0">
            We provide{' '}
            <Link to="/service-areas/camarillo" data-id="element-390" data-mp="26c81iajveh6o">
              mobile detailing in Camarillo
            </Link>
            ,{' '}
            <Link to="/service-areas/ventura" data-id="element-391" data-mp="2yyapzvj6hgtc">auto detailing in Ventura</Link>
            ,{' '}
            <Link to="/mobile-detailing-thousand-oaks" data-id="element-392" data-mp="2u7u9u3nz3h3a">
              detailing in Thousand Oaks
            </Link>
            , <Link to="/service-areas/simi-valley" data-id="element-393" data-mp="2p9sthqhxlvvi">Simi Valley</Link>,{' '}
            <Link to="/service-areas/moorpark" data-id="element-394" data-mp="3mo52gbzl53d2">Moorpark</Link>,{' '}
            <Link to="/service-areas/newbury-park" data-id="element-395" data-mp="3mqhszdjesm1q">Newbury Park</Link>, and{' '}
            <Link to="/service-areas/westlake-village" data-id="element-396" data-mp="3hw3uh29g9ysu">
              Westlake Village
            </Link>
            .
          </p>

          <h2 data-id="element-397" data-mp="3pb6257cny12c">Why Ventura County Trusts Mike's Pro Detail</h2>
          <p data-id="element-398" data-mp="3u8fzraa7hj19">
            With a 5-star reputation built across Ventura County, Full Detail
            Pro has earned the loyalty of drivers who demand the very best for
            their vehicles. Our success comes down to a simple philosophy:
            uncompromising quality, genuine convenience, and treating every
            customer's car with the same care we would give our own. We use only
            premium, eco-friendly products and professional-grade equipment, and
            we never rush a job — because a truly great detail takes time and
            attention.
          </p>
          <p data-id="element-399" data-mp="qqo15d1ke0u3">
            Our experienced technicians understand the unique challenges of
            Southern California vehicles: relentless UV exposure that fades
            paint and cracks interiors, coastal salt air that accelerates
            corrosion, and fine inland dust that works its way into every
            surface. Every service we provide is designed to combat these
            conditions and keep your vehicle protected, beautiful, and holding
            its value for years to come.
          </p>

          <h2 data-id="element-400" data-mp="2cmka9o41gipu">How Our Mobile Detailing Process Works</h2>
          <p data-id="element-401" data-mp="2hgf0zbi29xyf">
            Booking is simple. Call or text Mike directly, describe your vehicle
            and the service you need, and we will provide a clear quote and find
            a time that works for you — including weekends. On the day of your
            appointment, our fully equipped mobile unit arrives at your home or
            office with everything required to complete the detail on-site. You
            stay productive or relax while we transform your vehicle, and you
            inspect the results before we leave. It is professional auto
            detailing made effortless.
          </p>

          <h2 data-id="element-402" data-mp="160qd8hwzguwk">Book Your Mobile Detail Today</h2>
          <p data-id="element-403" data-mp="3ja80yferdg6u">
            Ready to experience the convenience and quality of mobile detailing
            in Ventura County? Whether you need a quick maintenance wash, a
            complete full detail, or specialty services like hybrid ceramic
            spray protection and headlight restoration, Mike's Pro Detail is ready
            to bring the shop to you. Call or text <a href="tel:8183819905" data-id="element-404" data-mp="35gyv2oq0rct2">(818) 381-9905</a>{' '}
            today, or <Link to="/contact" data-id="element-405" data-mp="62n40iuzjfdd">request a free quote online</Link>,
            and discover why drivers throughout Camarillo, Ventura,
            Thousand Oaks, and all of Ventura County trust us with their
            vehicles.
          </p>
        </div>
      </div>
    </section>;
}